import React, {Component} from "react";

import WithUserData from "../WithUserData";
import styles from "../../TalentApplication/styles.module.css";
import Spinner from "../../../assets/Spinner/Spinner";

export default class Shop extends Component {

    render() {
        return (
            <WithUserData>
                {({ user }) => {
                    if(!!user?.membership){
                        window.location.href = process.env.REACT_APP_SHOP_SELLER_DASHBOARD_URL;
                    }
                    return (
                        <div className={`w-full h-full ${styles.Loading}`}>
                            <Spinner color='black'/>
                        </div>
                    )
                }}
            </WithUserData>
        );
    }
}
